import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';

import { FileExclamationOutlined } from '@ant-design/icons';
import { useImageControls } from './common/useImageControls';
import { ImageControls } from './common/ImageControls';
import { Recovery } from './common/Recovery';
import { ViewerPropertiesComplete } from '../model';
import { useResource } from './common/useResource';
import { _urls } from '../../../apiScenarios';
import { ProviderResult } from './common/image';
export const MediaImage: React.FC<ViewerPropertiesComplete> = ({
  filename,
  src,
  attachEventsToDocument,
  onMetadataAvailable,
  imageMetadataProvider,
}) => {
  const { data } = useResource<ProviderResult>(imageMetadataProvider?.loadURL);

  const [errorState, setErrorState] = useState<'ok' | 'error' | 'recovering'>('ok');
  const containerRef = useRef<HTMLDivElement>(null);
  const imageRef = useRef<HTMLImageElement>(null);
  const [rd, setRD] = useState<undefined | { width: number; height: number }>(undefined);

  const controller = useImageControls(
    errorState === 'ok',
    containerRef,
    attachEventsToDocument,
    rd,
  );

  const { cssTransform } = controller;

  useEffect(() => {
    if (errorState === 'recovering' && imageRef.current) {
      imageRef.current.src = '';
      imageRef.current.src = src;
    }
  }, [errorState, src]);
  useEffect(() => {
    if (data !== undefined && data.metadata.resolution !== undefined) {
      onMetadataAvailable({
        width: data.metadata.resolution[0],
        height: data.metadata.resolution[1],
      });
    }
  }, [data, onMetadataAvailable]);
  useEffect(() => {
    setErrorState('recovering');
  }, [src]);

  // useLayoutEffect позволяет избежать моргания.
  useLayoutEffect(() => {
    const img = imageRef.current;
    if (img === null) return;
    if (errorState === 'ok') {
      img.style.transform = cssTransform;
      img.style.opacity = 'unset';
    } else {
      img.style.transform = 'unset';
      img.style.opacity = '0';
    }
  }, [errorState, cssTransform]);

  const image = (
    <img
      ref={imageRef}
      className="gen-file-viewer__image"
      src={src}
      alt={filename}
      onMouseDown={controller.dragOnMouseDown}
      onDragStart={(e) => e.preventDefault()}
      onError={() => {
        setErrorState('error');
      }}
      onLoad={(e) => {
        const self = e.target as HTMLImageElement;
        // Не показываем размер картинки: https://jira.my.games/browse/MYUA-4831
        // берем реальный размер картинки из https://jira.my.games/browse/MYUA-8542
        setRD({ width: self.naturalWidth, height: self.naturalHeight });

        setErrorState('ok');
      }}
    />
  );
  return (
    <div className="gen-file-viewer__image-container gen-file-viewer__container" ref={containerRef}>
      {image}
      {errorState === 'error' && (
        <div style={{ fontSize: 80 }}>
          <FileExclamationOutlined />
        </div>
      )}
      {errorState === 'ok' && <ImageControls controller={controller} />}
      {errorState === 'error' && <Recovery onRecovery={() => setErrorState('recovering')} />}
    </div>
  );
};
